import { render } from "./ConfigPage.vue?vue&type=template&id=414e3015"
import script from "./ConfigPage.vue?vue&type=script&lang=js"
export * from "./ConfigPage.vue?vue&type=script&lang=js"
script.render = render

export default script